import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { BIZ, NAV } from "../lib/content";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-dst-ink border-t border-white/10 overflow-hidden">
    <div className="container-dst pt-20 pb-10">
      {/* Massive wordmark */}
      <div className="border-b border-white/10 pb-10 mb-12">
        <h2 className="font-oswald font-700 uppercase leading-[0.8] tracking-tighter text-[22vw] lg:text-[16vw] text-white/5 select-none">
          DST
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="eyebrow text-dst-red mb-4">Dynamic Sports Training</div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Elite sports performance plus baseball and softball instruction in New Braunfels, TX. We don't simply improve athletes — we develop competitors.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={BIZ.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 grid place-items-center border border-white/15 text-white/70 hover:bg-dst-red hover:text-white hover:border-dst-red transition-colors">
              <Instagram size={18} />
            </a>
            <a href={BIZ.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 grid place-items-center border border-white/15 text-white/70 hover:bg-dst-red hover:text-white hover:border-dst-red transition-colors">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div>
          <div className="eyebrow text-white/40 mb-5">Explore</div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/70 hover:text-dst-red transition-colors font-600">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow text-white/40 mb-5">Contact</div>
          <ul className="space-y-4 text-sm">
            <li><a href={BIZ.phoneHref} className="flex items-start gap-3 text-white/70 hover:text-white"><Phone size={18} className="text-dst-red mt-0.5" />{BIZ.phone}</a></li>
            <li><a href={`mailto:${BIZ.email}`} className="flex items-start gap-3 text-white/70 hover:text-white"><Mail size={18} className="text-dst-red mt-0.5" />{BIZ.email}</a></li>
            <li><a href={BIZ.maps} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/70 hover:text-white"><MapPin size={18} className="text-dst-red mt-0.5" /><span>{BIZ.address1}<br />{BIZ.address2}</span></a></li>
            <li className="flex items-start gap-3 text-white/70"><Clock size={18} className="text-dst-red mt-0.5" />Daily {BIZ.hours}</li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-white/40 mb-5">Find Us</div>
          <a href={BIZ.maps} target="_blank" rel="noreferrer" data-testid="footer-map" className="block group relative overflow-hidden border border-white/10">
            <iframe
              title="DST New Braunfels map"
              src="https://www.google.com/maps?q=6700%20I-35%20N%20Frontage%20Rd%20Suite%20106%20New%20Braunfels%20TX%2078130&output=embed"
              className="w-full h-44 grayscale contrast-125 opacity-70 group-hover:opacity-100 transition-opacity pointer-events-none"
              loading="lazy"
            />
          </a>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <p>© {new Date().getFullYear()} Dynamic Sports Training — New Braunfels, TX. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </div>
  </footer>
);
